
import request from "@/utils/request";
// 代理商用户充值
export function addRechargerecord() {
    return request({
      url: "/c/rechargerecord/add",
      method: "get",
    });
  } 
  
// 充值记录列表
export function getRechargerecord( data) {
    return request({
        url: "/c/rechargerecord/page",
        method: "get",
        params:data,

    });
}
// 充值套餐
export function getRechargepackage( data) {
    return request({
        url: "/c/rechargepackage/page",
        method: "get",
        params:data,

    });
}

// 获取自定义充值单次价格
export function getSingleCheckBalance( data) {
    return request({
        url: "c/rechargepackage/getSingleCheckBalance",
        method: "get",
        params:data,

    });
}

// 支付宝套餐充值
export function alipayPost( data) {
    return request({
        url: "c/api/alipay/pay",
        method: "post",
        data,

    });
}




  
